import runSsrSafely from '@utils/ssr/runSsrSafely';
import fetchTransactionPage from '@utils/ssr/fetchTransactionPage';

export default function ssrFetch(ctx) {
    const options = ctx.timeout ? {timeout: ctx.timeout} : {};
    return runSsrSafely(fetchTransactionPage({...ctx, options}));
}
